import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { UiStyleService } from '../../services/ui-style.service';

@Component({
  selector: 'e5core-ui-search-menu',
  styleUrls: ['./../../css/default.css'],
  template: `
  <span [ngSwitch]="style.current()">
    <e5core-ui-search-menu-box *ngSwitchCase='0' (search)="onSearch()" (reset)="onReset()" (refresh)="onRefresh()"></e5core-ui-search-menu-box>
    <e5core-ui-search-menu-bootstrap *ngSwitchCase='1' (search)="onSearch()" (reset)="onReset()" (refresh)="onRefresh()"></e5core-ui-search-menu-bootstrap>
    <e5core-ui-search-menu-material *ngSwitchCase='2' (search)="onSearch()" (reset)="onReset()" (refresh)="onRefresh()"></e5core-ui-search-menu-material>
  </span>`
})
export class E5coreUiSearchMenuComponent implements OnInit {

  @Output() search = new EventEmitter() ;
  @Output() reset = new EventEmitter() ;
  @Output() refresh = new EventEmitter() ;

  constructor(public style:UiStyleService) { }

  ngOnInit() {
  }

  public onSearch() {
    this.search.emit() ;
  }

  public onReset() {
    this.reset.emit() ;
  }

  public onRefresh() {
    this.refresh.emit() ;
  }
}
